module.exports = __webpack_public_path__ + "fd52ac38b7ebad0b2f27f460c10fc36f.jpg";